import Lookup from 'src/componentes/select2';

const TipoRecursoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoRecursoLookup"
    {...rest}
  />
);

export default TipoRecursoLookup;
